import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchUploadFilesFailure,
  fetchUploadFilesSuccess,
} from "../slices/features/uploadFiles";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* uploadFilesSaga(action: any) {
  const { payload } = action;
  const { data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.uploadFiles,
      baseUrl,
      data
    );

    yield put(fetchUploadFilesSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message || error?.data?.message;

    payload?.cbFailure && payload?.cbFailure(message || "Please Try Again");

    yield put(fetchUploadFilesFailure({ statusCode, statusText }));
  }
}

export function* watchUploadFiles() {
  yield takeLatest(RequestTypes.UPLOADFILES_REQUEST, uploadFilesSaga);
}
